const paddings = {
  default: 20,
  contentLogin: 30,
  input: 10,
  alternative: 15,
  reset: 0,
};

export default paddings;
